import { SERVER_DOMAIN } from '../config';

export const createPayment = async (paymentMethod, plan, userData) => {
  try {
    const response = await fetch(`${SERVER_DOMAIN}/payments/create/${paymentMethod}`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'bypass-tunnel-reminder': 'true'
      },
      body: JSON.stringify({
        user_id: userData.telegramId,
        plan: plan
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Ошибка создания платежа');
    }

    const data = await response.json();
    
    if (data.status === 'success') {
      const paymentUrl = paymentMethod === 'stripe' ? data.sessionUrl : data.paymentUrl;
      if (!paymentUrl) throw new Error('URL для оплаты не получен');

      return {
        success: true,
        sessionUrl: paymentMethod === 'stripe' ? paymentUrl : null,
        paymentUrl: paymentMethod === 'yoomoney' ? paymentUrl : null
      };
    }
    
    throw new Error('Ошибка создания платежа');
  } catch (error) {
    throw new Error(`Ошибка оплаты: ${error.message}`);
  }
};

export const cancelSubscription = async (userId) => {
  const response = await fetch(`${SERVER_DOMAIN}/payments/subscription/${userId}/cancel`, {
    method: 'POST',
    headers: {
      'bypass-tunnel-reminder': 'true'
    }
  });
  if (!response.ok) throw new Error('Ошибка отмены подписки');
  return await response.json();
};

export const getPaymentViewData = async (userId) => {
  try {
    const response = await fetch(`${SERVER_DOMAIN}/payments/payment_view?user_id=${userId}&language=ru`, {
      headers: {
        'bypass-tunnel-reminder': 'true'
      }
    });
    
    if (!response.ok) {
      throw new Error('Ошибка получения планов оплаты');
    }
    
    const data = await response.json();
    console.log('API Response:', data); // Для отладки
    
    if (!data.payment_plans || !Array.isArray(data.payment_plans)) {
      throw new Error('Некорректные данные планов оплаты');
    }
    
    return data;
  } catch (error) {
    console.error('Payment plans error:', error);
    throw error;
  }
};